module.exports = __webpack_public_path__ + "static/img/bg_reward_item_blue.fcbe74b0.png";